import Owner from './owner.svg';
import Entrepreneur from './entrepreneur.svg';
import Jetsetter from './jetsetter.svg';
import Landlord from './landlord.svg';
import Investor from './investor.svg';
import Mogul from './mogul.svg';
/* import Magnate from './magnate.svg'; */
import MagnateIcon from './MagnateIcon/MagnateIcon';
/* import Benefactor from './benefactor.svg'; */
import BenefactorIcon from './BenefactorIcon/BenefactorIcon';
import OwnerWhite from './owner_white.svg';
import EntrepreneurWhite from './entrepreneur_white.svg';
import JetsetterWhite from './jetsetter_white.svg';
import LandlordWhite from './landlord_white.svg';
import InvestorWhite from './investor_white.svg';
import MogulWhite from './mogul_white.svg';
import MagnateWhite from './magnate_white.svg';
import BenefactorWhite from './benefactor_white.svg';

export const levelIcons: LevelIconsInterface = {
	owner: Owner,
	entrepreneur: Entrepreneur,
	jetsetter: Jetsetter,
	landlord: Landlord,
	investor: Investor,
	mogul: Mogul,
	magnate: MagnateIcon,
	benefactor: BenefactorIcon,
	ownerwhite: OwnerWhite,
	entrepreneurwhite: EntrepreneurWhite,
	jetsetterwhite: JetsetterWhite,
	landlordwhite: LandlordWhite,
	investorwhite: InvestorWhite,
	mogulwhite: MogulWhite,
	magnatewhite: MagnateWhite,
	benefactorwhite: BenefactorWhite,
};

export interface LevelIconsInterface {
	owner: React.FC<React.SVGProps<SVGSVGElement>>;
	ownerwhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	entrepreneur: React.FC<React.SVGProps<SVGSVGElement>>;
	entrepreneurwhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	jetsetter: React.FC<React.SVGProps<SVGSVGElement>>;
	jetsetterwhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	landlord: React.FC<React.SVGProps<SVGSVGElement>>;
	landlordwhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	investor: React.FC<React.SVGProps<SVGSVGElement>>;
	investorwhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	mogul: React.FC<React.SVGProps<SVGSVGElement>>;
	mogulwhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	magnate: React.FC<React.SVGProps<SVGSVGElement>>;
	magnatewhite: React.FC<React.SVGProps<SVGSVGElement>>;
	/* -------------------------------------------------------------------------- */
	benefactor: React.FC<React.SVGProps<SVGSVGElement>>;
	benefactorwhite: React.FC<React.SVGProps<SVGSVGElement>>;
}
